import * as Yup from 'yup';

// `reason` is required only when approvedIds is empty (full rejection).
const reviewSchema = Yup.object({
  approvedIds: Yup.array().of(Yup.number()),
  reason: Yup.string().when('approvedIds', {
    is: (ids) => Array.isArray(ids) && ids.length === 0,
    then: (schema) => schema.trim().required('Rejection reason is required'),
    otherwise: (schema) => schema,
  }),
});

export default reviewSchema;
